import { Hander } from "../Login/AppStyle";

export default function GeneralHander ({ section }) {
    return(
        <Hander>
            <h1 className="hander">{section}</h1>
        </Hander>
    )

}
